import {connect} from 'react-redux';

import {makeMapDispatchToProps} from '../../../../helpers/reselectHelpers';
import {createCustomFieldAsyncAction} from '../../../../store/data/customFields/customFieldsActions';
import {CreateCustomFieldDropdown} from './createCustomFieldDropdown';

/*
 * Redux.
 */

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  createCustomFieldAsync: createCustomFieldAsyncAction,
}));

export const CreateCustomFieldDropdownContainer = connect(
  null,
  mapDispatchToProps,
)(CreateCustomFieldDropdown);
